import { RootState } from 'dataStore/state'
import { useSelector } from 'react-redux'
import { useActions } from 'hooks/useActions'

import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar'
import { styled, useTheme } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import MenuIcon from '@mui/icons-material/Menu'

import EnableNotificationsButton from 'components/newOrderNotifications/EnableNotificationsButton'
import { OpenPwaInstallGuideButton } from 'components/pwa/InstallPwaGuideHost'
import { colors, settings } from 'ThemeStyle'
import UserMenu from './../../../components/userMenu/index'

interface AppBarProps extends MuiAppBarProps {
  open: boolean
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  marginLeft: settings.sidebarClose,
  width: `calc(100% - ${settings.sidebarPanelClose}px)`,
  zIndex: theme.zIndex.drawer + 1,
  boxShadow: 'none',
  border: 'none',
  color: theme.palette.text.primary,
  backgroundColor: colors.white,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: settings.sidebarWidth,
    width: `calc(100% - ${settings.sidebarWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  [theme.breakpoints.down('lg')]: {
    marginLeft: 0,
    width: '100%',
  },
}))

/**
 * Верхняя панель админки с кнопкой меню на мобильных.
 */
const Header = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const { sidebarState } = useSelector((state: RootState) => state.ui)
  const { setSidebar } = useActions()

  return (
    <AppBar position='fixed' open={sidebarState}>
      <Toolbar sx={{ minHeight: { xs: 56, sm: 64 }, px: { xs: 1, sm: 2 } }}>
        {isMobile && (
          <IconButton
            color='inherit'
            edge='start'
            aria-label='Открыть меню'
            onClick={() => setSidebar(true)}
            sx={{ mr: 1 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        {isMobile && (
          <Typography
            variant='subtitle1'
            noWrap
            sx={{ fontWeight: 600, color: '#76A741', mr: 1 }}
          >
            Админ-панель
          </Typography>
        )}

        <Box sx={{ flexGrow: 1 }} />
        <OpenPwaInstallGuideButton />
        <EnableNotificationsButton />
        <UserMenu />
      </Toolbar>
    </AppBar>
  )
}

export default Header
